import apiClient, { unwrap } from './client';
import type { ApiEnvelope, DashboardData } from '@types';

export const dashboardApi = {
  /** Dashboard aggregates (F8.2), all computed server-side. */
  get: async (): Promise<DashboardData> => {
    const envelope =
      await apiClient.get<ApiEnvelope<DashboardData>>('/v1/dashboard');
    return unwrap(envelope);
  },
};

export default dashboardApi;
